import { COLOR_ELEVATION_01 } from "./../../config";
import styled from "styled-components";
import {
  COLOR_ADEGA_BLUE,
  COLOR_ADEGA_BLUE_HEX,
  COLOR_ADEGA_RED,
  COLOR_DARK_GRAY,
  COLOR_DASHBOARD_ELEVATION_01,
  COLOR_LIGHT_GRAY,
  COLOR_PLACEHOLDER,
  COLOR_TEXT,
  hexToRgba,
  MOBILE_WIDTH,
  spacing,
} from "../../config";
import { IoCloseOutline } from "react-icons/io5";
import { COLOR_PRIMARY_GREEN, GREEN_GRADIENT } from "../../styleConfig";

interface IContainer {
  isOpened: boolean;
}

export const Container = styled.div<IContainer>`
  z-index: 100000000;
  min-width: 256px;
  width: 0px;

  transition: 0.3s;
  overflow-y: auto;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
  max-height: 100vh;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${COLOR_PRIMARY_GREEN};
  @media (max-width: ${MOBILE_WIDTH}) {
    position: fixed;
    top: 0;
    left: ${(p) => (p.isOpened ? "0px" : "-256px")};
  }
`;

export const Logo = styled.div`
  width: 80px;
  height: 70px;
  background-image: url(/images/logo-bocchi.png);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  margin-top: ${spacing(2)};
`;

export const CloseMobile = styled(IoCloseOutline)`
  font-size: 30px;
  font-weight: bold;
  cursor: pointer;
  box-sizing: content-box;
  border: 4px solid transparent;
  transition: 0.2s;
  border-radius: 6px;

  &:hover {
    border: 4px solid rgba(${hexToRgba(COLOR_ADEGA_BLUE_HEX, 0.25)});
  }
`;

export const Novo = styled.p`
  color: ${COLOR_ADEGA_RED};
  font-size: 11px;
  margin-left: ${spacing(1)};
  margin-top: -10px;
`;

export const Overlay = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
  z-index: 3;
  background-color: rgba(0, 0, 0, 0.4);
`;

export const LogoContainer = styled.div`
  width: 100%;
  height: 70px;
  padding: ${spacing(3)} ${spacing(4)};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${spacing(5)};
  & > svg {
    margin-bottom: -10px;
    color: ${COLOR_ELEVATION_01};
    width: 90%;
    display: none;
  }

  & div {
    display: block;
  }

  @media (max-width: ${MOBILE_WIDTH}) {
    justify-content: flex-end;
    & svg {
      display: block;
    }
    & div {
      display: none;
    }
  }
`;

export const NavContainer = styled.div`
  width: 100%;
  height: fit-content;
`;

interface IItemContainer {
  itemName: string;
  location: string;
}

export const ItemContainer = styled.div<IItemContainer>`
  width: 100%;
  height: 55px;
  cursor: pointer;
  margin-bottom: ${spacing(1)};
  position: relative;
  padding: 0 ${spacing(4)};
  display: flex;
  align-items: center;
  color: lightgray;
  transition: 0.3s;

  & > span {
    display: ${(p) => (p.itemName == p.location ? "block" : "none")};
  }

  &:hover {
    color: ${COLOR_ELEVATION_01};
  }

  &:hover svg {
    color: ${COLOR_ELEVATION_01};
  }

  & svg {
    width: 22px;
    font-size: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    transition: 0.5s;
  }
`;

export const ItemText = styled.p`
  font-weight: 500;
  font-size: 20px;
`;

export const NavMark = styled.span`
  width: 5px;
  border-radius: 0 10px 10px 0;
  height: 100%;
  background-color: ${COLOR_ELEVATION_01};
  position: absolute;
  left: 0;
  top: 0;
`;

export const VersionLabel = styled.p`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding-bottom: 10px;
  text-align: center;
  color: white;
  font-weight: 100;
  font-size: 12px;
  opacity: 0.7;
`;
